// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "01906a185c5a1263ce5c" + ".css";
};